import { ImageAvatar } from 'app/components/images/ImageAvatar'
import {UserModel} from 'app/modules/auth/models/UserModel'
import clsx from 'clsx'
import React, {FC} from 'react'
import {useSelector, shallowEqual} from 'react-redux'
import {RootState} from 'setup'
import {HeaderUserMenu} from '../../../partials'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px'


const Topbar: FC = () => {
  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel

  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      {/* begin::User */}
      <div
        className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
        id='kt_header_user_menu_toggle'
      >
        {/* begin::Toggle */}
        <div className='d-flex flex-column align-items-end pe-5'>
          <div className='fw-bolder d-flex  fs-5'>
            {user.firstName} {user.lastName}
            <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'></span>
          </div>
          <a href='#/' className='fw-bold text-muted text-hover-primary fs-7'>
           
          </a>
         
        </div>
        <div
          className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >          
          <ImageAvatar  fielName={user.avatar} />
        </div>

        <HeaderUserMenu />
        {/* end::Toggle */}
      </div>
      {/* end::User */}
    </div>
  )
}

export {Topbar}
